import React from 'react';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import cn from 'classnames';
import { DialogClose } from '@radix-ui/react-dialog';

import styles from './header-with-image.module.scss';
import { Text } from '../atoms/text/text';
import { Space } from '../atoms/space/space';
import { Heading } from '../atoms/heading/heading';

type HeaderWithImageProps = {
    preTitle?: string;
    mainTitle: string;
    icon?: React.ReactNode;
    imgSrc: string;
    srcSet?: {
        small: string;
        medium: string;
        large: string;
    };
    tallImage?: boolean;
};

export const HeaderWithImage = ({
    preTitle,
    mainTitle,
    icon,
    imgSrc,
    srcSet,
    tallImage
}: HeaderWithImageProps) => {
    const headerClass = cn(styles.header, {
        [styles.headerTall]: tallImage
    });

    return (
        <div className={headerClass}>
            <img
                srcSet={
                    srcSet
                        ? `${srcSet?.small}, ${srcSet?.medium} 2x, ${srcSet?.large} 3x`
                        : ''
                }
                src={imgSrc}
                className={styles.headerImage}
                alt={mainTitle}
            />
            <div className={styles.headerImageOverlay} />
            <div className={styles.headerContent}>
                <Text size="oslo">{preTitle}</Text>
                <Space justify="between" align="center">
                    <Heading as="h2" className="mr-2">
                        {mainTitle}
                    </Heading>
                    {icon}
                </Space>
                <DialogClose asChild>
                    <Button
                        theme="text"
                        className={styles.closeBtn}
                        round
                        icon={<CloseIcon className="icon icon-white" />}
                    />
                </DialogClose>
            </div>
        </div>
    );
};
